import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Water_Supply_Systems_and_Management_for_UBL_poster from '../../../Assets/Images/ProjectsImg/Water_Supply_Systems_and_Management_for_UBL/Water.jpeg';

const Water_Supply_Systems_and_Management_for_UBL = () => {

    return (
        <div className="mt-5">
            <h4>Three Day’s Certified Course on Water, Sewage Management, STP Management, Plumbing & Allied Sectors</h4>

            <div className="card mt-5">
                <img
                    src={Water_Supply_Systems_and_Management_for_UBL_poster}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p>As India is experiencing rapid urbanization there is a huge demand for skilled workers who can deliver quality infrastructure design, implementation and management. The course is intended for flow of knowledge, experiences, resources and connections for development of capable, qualified workforce and domain knowledge for water, sewage management, STP management, plumbing & allied se</p>
            </div>

            <div>
                <p><strong>Aim:</strong> The programme aims to develop trained “urban managers” in the field of water supply, sewerage management, STP management, plumbing and allied sectors.</p>
                <p><strong>Duration, Course Structure and Credits:</strong> The three day’s certified courses on Water, Sewage Management, STP Management, Plumbing & Allied Sectors is divided into three Modules each, each for a duration of three days. The first Course prepares the participants for dealing with water supply. The second Course aims to develop skills for Sewer and Storm Water Management. The third Course is based on Sewage Treatment Plant Management and Operations.</p>

                <p><strong>Course Title: Water Supply Systems:</strong> </p>
                <p><strong>Total Duration:</strong> 24 Hours (1.5 credits)</p>
                <ul>
                    <li>Theory: 8 Hours</li>
                    <li>Practical: 14 Hours</li>
                    <li>Case Studies: 2 Hours</li>
                </ul>

                <p><strong>Course Title: Sewer and Storm Water Management</strong> </p>
                <p><strong>Total Duration:</strong> 24 Hours</p>
                <ul>
                    <li>Theory: 8 Hours</li>
                    <li>Practical: 14 Hours</li>
                    <li>Case Studies: 2 Hours</li>
                </ul>

                <p><strong>Course Title: Sewage Treatment Plant Management and Operations</strong> </p>
                <p><strong>Total Duration:</strong> Approx. 22–24 Hours</p>
                <ul>
                    <li>Theory: 8 Hours</li>
                    <li>Practical: 1 Day Field Visit + 4 Hours Hands-on</li>
                    <li>Case Studies: 2 Hours</li>
                </ul>

                <p><strong>Timeline:</strong> Upcoming</p>

                {/* <p><strong>Status:</strong> Completed</p> */}
            </div>
        </div>
    );
};

export default Water_Supply_Systems_and_Management_for_UBL;

